import { useQueryClient } from '@tanstack/react-query'
import { useRealtime } from '@/lib/ws/useRealtime'

export function MailRealtime() {
  const qc = useQueryClient()
  useRealtime(
    // sent: gönderim worker'da kaydedildi; Gönderilenler ancak o an tazelenebilir.
    (event) => event === 'mail.message.received' || event === 'mail.message.sent',
    () => {
      void qc.invalidateQueries({ queryKey: ['mail'] })
    },
  )
  return null
}
